import React from 'react';

import { HStack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { customTheme } from 'theme';

import { getProviderAlias } from 'components/DataDisplay';
import { PrimaryButton } from 'components/DataEntry';
import { NotifyIcon, ThirdPartyIcon, TicketIcon } from 'components/Icons';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

export const VulnerabilityActions = () => {
  const { resourceInsight } = useSelector(selectActiveResource);
  const renderItem = (label, icon) => (
    <PrimaryButton
      leftIcon={icon}
      //onClick={onClick}
      border="none"
      bg="transparent"
      fontSize="md"
      color={customTheme.colors.grey}
      iconColor={customTheme.colors.grey}
      _hover={{}}
      _focus={{}}
      _active={{}}
      cursor="not-allowed"
      px={0}
    >
      {label}
    </PrimaryButton>
  );

  return (
    <HStack spacing={6}>
      {renderItem(
        getProviderAlias(resourceInsight.data?.provider),
        <ThirdPartyIcon w={6} h={6} strokeWidth={1.5} />,
      )}
      {renderItem('Notify', <NotifyIcon />)}
      {renderItem('Create ticket', <TicketIcon />)}
    </HStack>
  );
};
